import { Injectable } from '@angular/core';
import { ReportsConnector } from './reports.connector';
import { PaymentHistoryDetailsRequestConfig, PaymentHistoryRequestConfig } from './models/payment-history.model';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  constructor(private reportsConnector: ReportsConnector) {}

  getPricingStatus() {
    return this.reportsConnector.getPricingStatus();
  }

  getPurchaseSummary() {
    return this.reportsConnector.getPurchaseSummary();
  }

  getPurchaseSummaryDetails(reference: string) {
    return this.reportsConnector.getPurchaseSummaryDetails(reference);
  }

  getCreditSummary() {
    return this.reportsConnector.getCreditSummary();
  }

  getPaymentHistory(config: PaymentHistoryRequestConfig) {
    return this.reportsConnector.getPaymentHistory(config);
  }

  getPaymentHistoryDetails(config: PaymentHistoryDetailsRequestConfig) {
    return this.reportsConnector.getPaymentHistoryDetails(config);
  }
}
